const ignorePaths = [
  '/logout',
  '/authenticating',
  '/auth/callback',
  '/auth/login',
  '/unauthenticated',
  '/auth/refresh',
  '/',
];

/**
 * A safe redirect target must be a same-origin relative path. Reject anything
 * that could escape the current origin (open redirect, CWE-601):
 *   - values not starting with a single `/`
 *   - protocol-relative (`//evil`) or backslash (`/\evil`, `\/evil`) prefixes
 *   - embedded backslashes, control characters, or whitespace
 *   - values containing a scheme separator (`:`) before any path segment
 *
 * This is the validating (boolean) counterpart to `sanitizeRedirectPath`, which
 * coerces a value to a safe path. Keep the two in sync when changing either.
 */
const isSafeSameOriginPath = (path: string): boolean => {
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//') || path.startsWith('/\\')) return false;
  // eslint-disable-next-line no-control-regex -- intentionally rejecting control chars
  if (/[\\\s\u0000-\u001f]/.test(path)) return false;
  // A scheme separator in the path portion (before any query string) indicates
  // an attempt to smuggle an absolute URL (e.g. `/foo:bar`, `javascript:`).
  const pathname = path.split(/[?#]/)[0];
  if (pathname.includes(':')) return false;
  return true;
};

export const isValidIntegrationsRedirectPath = (
  path: string | undefined | null
) => {
  if (!path) return false;
  if (!isSafeSameOriginPath(path)) return false;
  return !ignorePaths.some((ignorePath) => {
    if (ignorePath === '/') {
      // Match exact root path or root path with query parameters
      return path === '/' || path.startsWith('/?');
    }
    return path === ignorePath || path.startsWith(ignorePath);
  });
};
